import { apiV2 } from './axiosClient';

const basePath = 'report';

export const getReportList = async () => apiV2.get(`${basePath}/list`);
export const getReportDetail = async (id) => apiV2.get(`${basePath}/detail/${id}`);
